/**
 * AI Assistant helper
 * Provides a simple frontend bridge to the AI recommendations endpoint.
 */

 (function () {
  'use strict';

  const SHOP_DOMAIN = window.__ENV__?.SHOPIFY_SHOP || '';

  const DEFAULT_AI_API_HOST = 'https://getsimilarproductshttp-309132447778.us-central1.run.app';

  function getAiApiHost() {
    const preferredHost = window.__ENV__?.AI_API_HOST ||
                          window.__ENV__?.FEATURE_FLAGS_API_HOST ||
                          DEFAULT_AI_API_HOST ||
                          window.__ENV__?.SHOPIFY_HOST ||
                          window.location.origin;
    if (!preferredHost) {
      return '';
    }
    return preferredHost.replace(/\/+$/, '');
  }

  const API_HOST = getAiApiHost();
  const API_ENDPOINT = API_HOST
    ? `${API_HOST}/apps/ai/api/recommendations`
    : '/apps/ai/api/recommendations';

  async function fetchRecommendations(query, provider = 'gemini') {
    if (!query || !SHOP_DOMAIN) {
      throw new Error('Missing query or shop domain');
    }

    const response = await fetch(API_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        shop: SHOP_DOMAIN,
        query,
        provider
      })
    });

    const payload = await response.json();
    if (!response.ok) {
      throw new Error(payload.error || 'AI recommendation request failed');
    }

    return payload.recommendations || [];
  }

  function renderResults(container, items) {
    if (!container) return;
    container.innerHTML = '';

    if (!items || items.length === 0) {
      container.textContent = 'No AI recommendations available yet.';
      return;
    }

    const list = document.createElement('ol');
    list.className = 'ai-recommendation-list';

    items.forEach(item => {
      const li = document.createElement('li');
      li.textContent = typeof item === 'string' ? item : item.title || item.id || JSON.stringify(item);
      list.appendChild(li);
    });

    container.appendChild(list);
  }

  function handleButtonClick(event) {
    const button = event.target.closest('[data-ai-recommend]');
    if (!button) return;

    const wrapper = button.closest('[data-ai-assistant]');
    if (!wrapper) return;

    const queryInput = wrapper.querySelector('[data-ai-query]');
    const provider = button.dataset.aiProvider || 'gemini';
    const results = wrapper.querySelector('[data-ai-results]');

    const query = queryInput && queryInput.value ? queryInput.value.trim() : '';
    if (!query) {
      renderResults(results, ['Please enter a question or topic first.']);
      return;
    }

    button.disabled = true;
    button.dataset.state = 'loading';
    renderResults(results, ['Thinking...']);

    fetchRecommendations(query, provider)
      .then(items => renderResults(results, items))
      .catch((error) => {
        renderResults(results, [`AI error: ${error.message}`]);
      })
      .finally(() => {
        button.disabled = false;
        button.dataset.state = '';
      });
  }

  function init() {
    document.addEventListener('click', handleButtonClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
